import * as React from 'react'

import { useGiftIdeaListing } from './hooks/useGiftIdeaListing'
import { Pagination as BasePagination } from '../components/Pagination'

export function Pagination(): React.ReactElement {
  const {
    response,
    query: { page },
    setPage,
    href,
  } = useGiftIdeaListing()

  return <BasePagination page={page} getPageHref={(page) => href(setPage(page))} response={response} />
}
